export default __webpack_public_path__ + "static/media/ies_conferencistas_ENG.e42e0b35.png";